import React, { useEffect } from "react";
import { lazy, Suspense } from "react";
import "./App.css";

import { Outlet, BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import ProtectedRoute from "./components/ProtectedRoute";
import OTPVerification from "./pages/Auth/OTPVerification";
import Dashboard from "./pages/Dashboard";
import ContentManagementSystem from "./pages/ContentManagementSystem/ContentManagementSystem";
import BannerManagement from "./pages/BannerManagement/BannerManagement";
import NewsManagement from "./pages/NewsManagement/NewsManagement";
import QuizAndGameManagement from "./pages/QuizAndGameManagement/QuizAndGameManagement";
import PartnerUpdateManagement from "./pages/PartnerUpdateManagement/PartnerUpdateManagement";
import WinTicketManagement from "./pages/WinTicketManagement/WinTicketManagement";
import PartnerUpdateTypeManagement from "./pages/PartnerUpdateTypeManagement/PartnerUpdateTypeManagement";
import SaudiaCompetitionsManagement from "./pages/SaudiaCompetitionsManagement/SaudiaCompetitionsManagement";
import FormMaster from "./pages/FormMaster/FormMaster";
import PartnerStreamsManagement from "./pages/PartnerStreamsManagement/PartnerStreamsManagement";
import BookingTicket from "./pages/BookingTicket/BookingTicket";
import SoundTrack from "./pages/SoundTrack/SoundTrack";
import SaudiaMoment from "./pages/SaudiaMoment/SaudiaMoment";
import SurveyQuestionManagement from "./pages/SurveyQuestionManagement/SurveyQuestionManagement";
import SaudiaHolidayManagement from "./pages/SaudiaHolidayManagement/SaudiaHolidayManagement";
import Subscription from "./pages/Subscription/Subscription";
import AddSubscription from "./pages/Subscription/AddSubscription";
import ViewSubscription from "./pages/Subscription/ViewSubscription";
import AddDriver from "./pages/DriverManagment/AddDriver";

const Login = lazy(() => import("../src/pages/Auth/Login"));
const ForgotPassword = lazy(() => import("../src/pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../src/pages/Auth/ResetPassword"));
const AddBanner = lazy(() => import("./pages/BannerManagement/AddBanner"));
const UpdateBanner = lazy(() => import("./pages/BannerManagement/UpdateBanner"));
const EditBanner = lazy(() => import("./pages/BannerManagement/EditBanner"));
const ViewBanner = lazy(() => import("./pages/BannerManagement/ViewBanner"));
const AddNews = lazy(() => import("./pages/NewsManagement/AddNews"));
const UpdateNews = lazy(() => import("./pages/NewsManagement/UpdateNews"));
const EditNews = lazy(() => import("./pages/NewsManagement/EditNews"));
const AddQuizAndGame = lazy(() => import("./pages/QuizAndGameManagement/AddQuizAndGame"));
const UpdateQuizAndGame = lazy(() => import("./pages/QuizAndGameManagement/UpdateQuizAndGame"));
const EditQuizAndGame = lazy(() => import("./pages/QuizAndGameManagement/EditQuizAndGame"));
const ViewQuiz = lazy(() => import("./pages/QuizAndGameManagement/ViewQuiz"));
const AddPartnerUpdate = lazy(() => import("./pages/PartnerUpdateManagement/AddPartnerUpdate"));
const UpdatePartnerUpdate = lazy(() => import("./pages/PartnerUpdateManagement/UpdatePartnerUpdate"));
const EditPartnerUpdate = lazy(() => import("./pages/PartnerUpdateManagement/EditPartnerUpdate"));
const ViewPartnerUpdate = lazy(() => import("./pages/PartnerUpdateManagement/ViewPartnerUpdate"));
const AddWinTicket = lazy(() => import("./pages/WinTicketManagement/AddWinTicket"));
const UpdateWinTicket = lazy(() => import("./pages/WinTicketManagement/UpdateWinTicket"));
const EditWinTicket = lazy(() => import("./pages/WinTicketManagement/EditWinTicket"));
const ViewWinTicket = lazy(() => import("./pages/WinTicketManagement/ViewWinTicket"));
const AddPartnerUpdateType = lazy(() => import("./pages/PartnerUpdateTypeManagement/AddPartnerUpdateType"));
const UpdatePartnerUpdateType = lazy(() => import("./pages/PartnerUpdateTypeManagement/UpdatePartnerUpdateType"));
const ViewPartnerUpdateType = lazy(() => import("./pages/PartnerUpdateTypeManagement/ViewPartnerUpdateType"));
const AddSaudiaCompetition = lazy(() => import("./pages/SaudiaCompetitionsManagement/AddSaudiaCompetition"));
const ViewSaudiaCompetition = lazy(() => import("./pages/SaudiaCompetitionsManagement/ViewSaudiaCompetition"));
const AddFormMaster = lazy(() => import("./pages/FormMaster/AddFormMaster"));
const UpdateFormMaster = lazy(() => import("./pages/FormMaster/UpdateFormMaster"));
const ViewFormMaster = lazy(() => import("./pages/FormMaster/ViewFormMaster"));
const SurveyFormMaster = lazy(() => import("./pages/SurveyFormMaster/SurveyFormMaster"));
const AddSurvey = lazy(() => import("./pages/SurveyFormMaster/AddSurvey"));
const UpdateSurvey = lazy(() => import("./pages/SurveyFormMaster/UpdateSurvey"));
const ViewSurvey = lazy(() => import("./pages/SurveyFormMaster/ViewSurvey"));
const UserQuizResponse = lazy(() => import("./pages/QuizAndGameManagement/UserQuizResponse"));
const ViewUserQuizResponse = lazy(() => import("./pages/QuizAndGameManagement/ViewUserQuizResponse"));
const AddSaudiaHoliday = lazy(() => import("./pages/SaudiaHolidayManagement/AddSaudiaHoliday"));
const UpdateSaudiaHoliday = lazy(() => import("./pages/SaudiaHolidayManagement/UpdateSaudiaHoliday"));
const ViewSaudiaHoliday = lazy(() => import("./pages/SaudiaHolidayManagement/ViewSaudiaHoliday"));
const UpdateSaudiaCompetition = lazy(() => import("./pages/SaudiaCompetitionsManagement/UpdateSaudiaCompetition"));
const EditSaudiaCompetition = lazy(() => import("./pages/SaudiaCompetitionsManagement/EditSaudiaCompetition"));
const AddPartnerStream = lazy(() => import("./pages/PartnerStreamsManagement/AddPartnerStream"));
const UpdatePartnerStream = lazy(() => import("./pages/PartnerStreamsManagement/UpdatePartnerStream"));
const EditPartnerStream = lazy(() => import("./pages/PartnerStreamsManagement/EditPartnerStream"));
const ViewPartnerStream = lazy(() => import("./pages/PartnerStreamsManagement/ViewPartnerStream"));
const AddSurveyQuestion = lazy(() => import("./pages/SurveyQuestionManagement/AddSurveyQuestion"));
const UpdateSurveyQuestion = lazy(() => import("./pages/SurveyQuestionManagement/UpdateSurveyQuestion"));
const EditCustomerTermsAndConditions = lazy(() => import("./pages/ContentManagementSystem/Customer/EditTermsAndConditions"));
const EditCustomerPrivacyPolicy = lazy(() => import("./pages/ContentManagementSystem/Customer/EditPrivacyPolicy"));
const ViewNews = lazy(() => import("./pages/RecentNews/ViewNews"));

function App() {
  return (
    <>
      <ToastContainer
        position={"top-right"}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Router>
        <Suspense fallback="Loading....">
          <Routes>
            {/* Public Routes */}
            <Route exact path="" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/otp-verification" element={<OTPVerification />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-driver"
              element={
                <ProtectedRoute>
                  <AddDriver />
                </ProtectedRoute>
              }
            />
            <Route
              path="/banner-management"
              element={
                <ProtectedRoute>
                  <BannerManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-banner/:id"
              element={
                <ProtectedRoute>
                  <ViewBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/saudia-holiday-management"
              element={
                <ProtectedRoute>
                  <SaudiaHolidayManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-saudia-holiday/:id"
              element={
                <ProtectedRoute>
                  <ViewSaudiaHoliday />
                </ProtectedRoute>
              }
            />
            <Route
              path="/news-management"
              element={
                <ProtectedRoute>
                  <NewsManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quiz-and-game-management"
              element={
                <ProtectedRoute>
                  <QuizAndGameManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner-update-management"
              element={
                <ProtectedRoute>
                  <PartnerUpdateManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-partner-update/:id"
              element={
                <ProtectedRoute>
                  <ViewPartnerUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/win-ticket-management"
              element={
                <ProtectedRoute>
                  <WinTicketManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner-update-type-management"
              element={
                <ProtectedRoute>
                  <PartnerUpdateTypeManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/saudia-competitions-management"
              element={
                <ProtectedRoute>
                  <SaudiaCompetitionsManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form-master"
              element={
                <ProtectedRoute>
                  <FormMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-form-master"
              element={
                <ProtectedRoute>
                  <AddFormMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-form-master/:id"
              element={
                <ProtectedRoute>
                  <UpdateFormMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-form-master/:id"
              element={
                <ProtectedRoute>
                  <ViewFormMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/survey-form-master"
              element={
                <ProtectedRoute>
                  <SurveyFormMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-survey-form-master"
              element={
                <ProtectedRoute>
                  <AddSurvey />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-survey-form-master/:id"
              element={
                <ProtectedRoute>
                  <UpdateSurvey />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-survey-form-master/:id"
              element={
                <ProtectedRoute>
                  <ViewSurvey />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-quiz-response"
              element={
                <ProtectedRoute>
                  <UserQuizResponse />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-user-quiz-response/:id"
              element={
                <ProtectedRoute>
                  <ViewUserQuizResponse />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-saudia-competition/:id"
              element={
                <ProtectedRoute>
                  <ViewSaudiaCompetition />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner-streams-management"
              element={
                <ProtectedRoute>
                  <PartnerStreamsManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-partner-stream/:id"
              element={
                <ProtectedRoute>
                  <ViewPartnerStream />
                </ProtectedRoute>
              }
            />
            <Route
              path="/booking-ticket"
              element={
                <ProtectedRoute>
                  <BookingTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sound-track"
              element={
                <ProtectedRoute>
                  <SoundTrack />
                </ProtectedRoute>
              }
            />
            <Route
              path="/saudia-moment"
              element={
                <ProtectedRoute>
                  <SaudiaMoment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/survey-question-management"
              element={
                <ProtectedRoute>
                  <SurveyQuestionManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-banner"
              element={
                <ProtectedRoute>
                  <AddBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-saudia-holiday"
              element={
                <ProtectedRoute>
                  <AddSaudiaHoliday />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-news"
              element={
                <ProtectedRoute>
                  <AddNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-quiz-and-game"
              element={
                <ProtectedRoute>
                  <AddQuizAndGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-partner-update"
              element={
                <ProtectedRoute>
                  <AddPartnerUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-win-ticket"
              element={
                <ProtectedRoute>
                  <AddWinTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-partner-update-type"
              element={
                <ProtectedRoute>
                  <AddPartnerUpdateType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-saudia-competition"
              element={
                <ProtectedRoute>
                  <AddSaudiaCompetition />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-partner-stream"
              element={
                <ProtectedRoute>
                  <AddPartnerStream />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-banner/:id"
              element={
                <ProtectedRoute>
                  <UpdateBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-news/:id"
              element={
                <ProtectedRoute>
                  <UpdateNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-news/:id"
              element={
                <ProtectedRoute>
                  <ViewNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-quiz-and-game/:id"
              element={
                <ProtectedRoute>
                  <UpdateQuizAndGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-quiz/:id"
              element={
                <ProtectedRoute>
                  <ViewQuiz />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-partner-update/:id"
              element={
                <ProtectedRoute>
                  <UpdatePartnerUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-win-ticket/:id"
              element={
                <ProtectedRoute>
                  <UpdateWinTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-win-ticket/:id"
              element={
                <ProtectedRoute>
                  <ViewWinTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-partner-update-type/:id"
              element={
                <ProtectedRoute>
                  <UpdatePartnerUpdateType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-partner-update-type/:id"
              element={
                <ProtectedRoute>
                  <ViewPartnerUpdateType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-saudia-competition/:id"
              element={
                <ProtectedRoute>
                  <UpdateSaudiaCompetition />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-partner-stream/:id"
              element={
                <ProtectedRoute>
                  <UpdatePartnerStream />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-survey-question"
              element={
                <ProtectedRoute>
                  <AddSurveyQuestion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-survey-question/:id"
              element={
                <ProtectedRoute>
                  <UpdateSurveyQuestion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-banner"
              element={
                <ProtectedRoute>
                  <EditBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-saudia-holiday/:id"
              element={
                <ProtectedRoute>
                  <UpdateSaudiaHoliday />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-news"
              element={
                <ProtectedRoute>
                  <EditNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-quiz-and-game"
              element={
                <ProtectedRoute>
                  <EditQuizAndGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-partner-update"
              element={
                <ProtectedRoute>
                  <EditPartnerUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-win-ticket"
              element={
                <ProtectedRoute>
                  <EditWinTicket />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-saudia-competition"
              element={
                <ProtectedRoute>
                  <EditSaudiaCompetition />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-partner-stream"
              element={
                <ProtectedRoute>
                  <EditPartnerStream />
                </ProtectedRoute>
              }
            />
            <Route
              path="/content-management-system"
              element={
                <ProtectedRoute>
                  <ContentManagementSystem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer/edit-terms-and-conditions"
              element={
                <ProtectedRoute>
                  <EditCustomerTermsAndConditions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer/edit-privacy-policy"
              element={
                <ProtectedRoute>
                  <EditCustomerPrivacyPolicy />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <Subscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/add-subscription"
              element={
                <ProtectedRoute>
                  <AddSubscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/view-subscription"
              element={
                <ProtectedRoute>
                  <ViewSubscription />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
